export { hot as default } from "react-hot-loader";
